export default function TogglePill({ options = [], active, onChange }) {
  return (
    <div className="flex items-center bg-gray-100 px-2 py-1 rounded-lg">
      {options.map((opt) => {
        const isActive = active === opt.value;

        return (
          <button
            key={opt.value}
            onClick={() => onChange(opt.value)}
            className={`
  flex-1 min-w-0
  text-center rounded-lg font-medium transition-all
  px-4 py-2 whitespace-nowrap
  ${isActive ? "bg-toucanTeal text-white" : "text-[#222] hover:text-black"}
`}
            style={{ fontSize: "14px" }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
